import { ContentNode, Repository } from '../../types/Explorer';
import * as Constants from './ActionConstants';
import {
  InitializeNodes,
  InitializeNodesFailed,
  InitializeNodesSuccess,
  InitializeRepositories,
  InitializeRepositoriesFailed,
  InitializeRepositoriesSuccess
} from './ActionTypes';

export const initializeRepositories = (): InitializeRepositories => ({
  type: Constants.INITIALIZE_REPOSITORIES
});

export const initializeRepositoriesFailed = (): InitializeRepositoriesFailed => ({
  type: Constants.INITIALIZE_REPOSITORIES_FAILED
});

export const initializeRepositoriesSuccess = (
  repositories: Repository[]
): InitializeRepositoriesSuccess => ({
  type: Constants.INITIALIZE_REPOSITORIES_SUCCESS,
  payload: { repositories }
});

export const initializeNodes = (parentId: string): InitializeNodes => ({
  type: Constants.INITIALIZE_NODES,
  payload: { parentId }
});

export const initializeNodesFailed = (): InitializeNodesFailed => ({
  type: Constants.INITIALIZE_NODES_FAILED
});

export const initializeNodesSuccess = (
  nodes: ContentNode[]
): InitializeNodesSuccess => ({
  type: Constants.INITIALIZE_NODES_SUCCESS,
  payload: { nodes }
});
